export default "/images/7ff1046aaf9b326c46903222f85ee5c2.avif";